export enum SmoLanguage {
  chineseSimplified = 'chinese_simplified',
  chineseTraditional = 'chinese_traditional',
  english = 'english',
  french = 'french_noe'
}

export const allSmoLanguages: SmoLanguage[] = Object.values(SmoLanguage);
